import EditIcon from '@material-ui/icons/Edit';
//import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { ColumnContainer } from 'utils/columnsStyle';
import { movementSelected } from 'redux/actions/gasMovements/gasMovActions';
import { useDispatch } from 'react-redux';
import { editMovementMode } from 'redux/actions/gasMovements/gasMovActions';
//import { deleteMovementMode } from 'redux/actions/gasMovements/gasMovActions';
import { Add, Close, RemoveRedEye, RemoveRedEyeOutlined } from '@material-ui/icons';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const columns = [
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Codigo</span> ),
    accessor: "code",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.code) 
      ? String(row.code).toLowerCase().includes(filter.value.toLowerCase())
      : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Movimiento</span> ),
    accessor: "movement",
    filterable: true,
    filterMethod: (filter, row) =>
      row.movement
        ? row.movement.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Tipo</span> ),
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) =>
      row.type
        ? row.type.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Tipo de Movimiento</span> ),
    accessor: "movementType",
    filterable: true,
    filterMethod: (filter, row) =>
      row.movementType
        ? row.movementType.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Registro</span> ),
    accessor: "visibleRegister",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.visibleRegister) 
      ? String(row.visibleRegister).toLowerCase().includes(filter.value.toLowerCase())
      : "",
    Cell: ({ original }) => {
      return (
        <div style={{  
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          {
            original.visibleRegister === 1 
              ? <RemoveRedEye style={{ ...style,  color: '#759023'}} />
              : <RemoveRedEyeOutlined style={{ ...style,  color: '#e83737'}} />
          }
        </div>
      )
    }
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Inventario</span> ),
    accessor: "visibleInventory",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.visibleInventory) 
      ? String(row.visibleInventory).toLowerCase().includes(filter.value.toLowerCase())
      : "",
    Cell: ({ original }) => {
      return (
        <div style={{  
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          {
            original.visibleInventory === 1 
              ? <RemoveRedEye style={{ ...style,  color: '#759023'}} />
              : <RemoveRedEyeOutlined style={{ ...style,  color: '#e83737'}} />
          }
        </div>
      )
    }
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Cuenta Litros</span> ),
    accessor: "affectsLiterCounter",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.affectsLiterCounter) 
      ? String(row.affectsLiterCounter).toLowerCase().includes(filter.value.toLowerCase())
      : "",
    Cell: ({ original }) => {
      return (
        <div style={{  
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          {
            original.affectsLiterCounter === 1 
              ? "AFECTA"
              : "NO AFECTA"
          }
        </div>
      )
    }
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Mayorista</span> ),
    accessor: "isWholesaler",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.isWholesaler) 
      ? String(row.isWholesaler).toLowerCase().includes(filter.value.toLowerCase())
      : "",
      Cell: ({ original }) => {
        return (
          <div style={{  
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            {
              original.isWholesaler === 1 
                ? <Add style={{ ...style,  color: '#759023'}} />
                : <Close style={{ ...style,  color: '#e83737'}} />
            }
          </div>
        )
      }
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Tipo de Inventario</span> ),
    accessor: "inventoryType",
    filterable: true,
    filterMethod: (filter, row) =>
      row.inventoryType
        ? row.inventoryType.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Descripción</span> ),
    accessor: "description",
    filterable: true,
    filterMethod: (filter, row) =>
      row.description
        ? row.description.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Acciones</span> ),
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const openEdit = () => {
        dispatch(editMovementMode())
        original.modal()
        dispatch(movementSelected(original.id))
      }
      // const openEliminate = () => {
      //   dispatch(deleteMovementMode())
      //   original.modal()
      //   dispatch(movementSelected(original.id))
      // }
      //const { addMovement } = useSelector(state => state.gasMovements)
      return (
        <ColumnContainer>
          <EditIcon style={style} onClick={openEdit}/>
          {/* {
            addMovement && <DeleteIcon style={{ ...style,  color: '#e83737'}} onClick={openEliminate}/>
          } */}
        </ColumnContainer>
      )
    },
  },
];